const Item = require('app/components/checkout/mixins/Item')
const assign = require('object-assign')
const PropTypes = require('prop-types')
const Trans = require('app/components/trans/Trans')

class ProductItem extends Item {
  static get propTypes () {
    return assign({}, super.propTypes, {
      id: PropTypes.any.isRequired,
      price: PropTypes.number.isRequired,
      extras: PropTypes.object.isRequired,
      amount: PropTypes.number,
      options: PropTypes.object
    })
  }

  static get defaultProps () {
    return {
      amount: 1
    }
  }

  get className () {
    return super.className + ' product-item'
  }

  get total () {
    let total = this.props.price

    Object.keys(this.props.extras).forEach(key => {
      total += this.props.extras[key]
    })

    return total
  }

  renderDescription () {
    const { color } = this.props

    const colorPick = (color && typeof color.name === 'string')
      ? (<span className='color'><Trans>Farvenuance</Trans>: <b>{color.name}</b></span>)
      : null

    return (
      <div className='description'>
        {colorPick}
      </div>
    )
  }
}

module.exports = ProductItem
